import React, { useCallback } from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import { Box } from '@mui/material';

import { TextField, Button, Typography } from '@occc-app/design-system';
import { MagicLinkRequestInput } from '@occc/graphql';

import { validate } from '../validation';

export const loginFormId = 'loginForm';

type LoginFormProps = {
  onFormSubmit: (input: MagicLinkRequestInput) => void;
};

export const LoginForm: React.FC<LoginFormProps> = ({ onFormSubmit }) => {
  const renderForm = useCallback(
    ({ handleSubmit, submitting, valid }: FormRenderProps<MagicLinkRequestInput>) => (
      <form id={loginFormId} onSubmit={handleSubmit}>
        <TextField
          label='Email'
          id='identifier'
          name='identifier'
          type='text'
          inputProps={{
            'data-testid': 'identifier',
          }}
          margin='normal'
        />

        <Box mb={2}>
          <Button
            variant='contained'
            fullWidth={true}
            color='primary'
            onClick={handleSubmit}
            disabled={submitting || !valid}
            data-testid='login'
          >
            Log In with Email
          </Button>
        </Box>

        <Typography gutterBottom>
          Enter the email address associated with your account and we'll email you a magic link for
          a password-free log in.
        </Typography>
      </form>
    ),
    [],
  );

  return (
    <Form<MagicLinkRequestInput> onSubmit={onFormSubmit} render={renderForm} validate={validate} />
  );
};
